/**
 * Members directory (P2). Fixtures in demo mode; in live mode the directory is
 * the BetterAuth ACTIVE organization's member list (there is no /api/members —
 * identity lives with BetterAuth). Shape stays the screen's Member {id,name,role};
 * `id` is the auth USER id (matches session.userRef / assignee refs).
 */
import { useEffect, useState } from 'react';
import type { Member } from './contract';
import { getFullOrganization } from './authApi';
import { displayHandle } from './session';
import { FIXTURES } from './fixtures';

const USE_FIXTURES = (import.meta.env.VITE_USE_FIXTURES as string | undefined) !== 'false';

export function useMembers(orgId: string): { members: Member[]; loading: boolean } {
  const [members, setMembers] = useState<Member[]>(USE_FIXTURES ? FIXTURES.members : []);
  const [loading, setLoading] = useState(!USE_FIXTURES);
  useEffect(() => {
    if (USE_FIXTURES || !orgId) return;
    let live = true;
    void getFullOrganization().then((org) => {
      if (!live) return;
      setMembers(
        (org?.members ?? []).map((m) => ({
          id: m.userId,
          name: displayHandle(m.user.name, m.user.email),
          role: m.role === 'owner' || m.role === 'admin' ? 'Manager' : 'User',
        })),
      );
      setLoading(false);
    });
    return () => {
      live = false;
    };
  }, [orgId]);
  return { members, loading };
}
